module.exports = __webpack_public_path__ + "static/media/Exambly Welcome page 33172-01-finishig-studies.18b31d70.gif";